<template>
  <v-text-field
    v-model="password"
    :append-icon="show === true ? 'mdi-eye' : 'mdi-eye-off'"
    :type="show === true  ? 'text' : 'password'"
    :label="label"
    :disabled="disabled"
    @click:append="show = !show"
    @input="emitNewVal"
  ></v-text-field>
</template>
     
</template>

<script>
export default {
  name: "my-password-field",
  props: {
    value: undefined,
    label: null,
    disabled: false
  },
  data() {
    return {
      show: false,
      password: null
    };
  },
  watch: {
    value: function(newVal, oldVal) {
      // watch it
      if (newVal) {
        this.password = newVal;
      }
    }
  },
  mounted() {
    if (this.value) this.password = this.value;
  },
  methods: {
    emitNewVal(elem) {
      this.$emit("input", this.password);
    }
  }
};
</script>